import React from 'react'
import './WinnersAboutUs.css'
import img1 from '../../Images/Rectangle 427.png'
import img2 from '../../Images/Rectangle 428.png'
import img3 from '../../Images/Rectangle 429.png'
const FavProperties = () => {
  return (
    <>
     <section className='fav_properties_section'>
        <h1 className='fav_client_properties_head'>Some of Most Favourite Client Properties</h1>
        <div className='fav_properties_images_wrapper'>
            <div className='fav_property_img'>
                <img src={img1}></img>
            </div> 
            <div className='fav_property_img'>
            <img src={img2}></img>
            </div>
            <div className='fav_property_img'>
            <img src={img3}></img>
            </div>
        </div>
     </section> 
    </>
  )
}

export default FavProperties
